<template>
	<div id="content">
		<EditContentSlide />
		<NewContentSlide />
		<EditTags />
		<ContentBrowser v-bind:isEditable="true" />
	</div>
</template>

<script>
	import isLoggedIn from '@/services/IsLoggedIn.js';
	import EditContentSlide from '@/components/content/EditContentSlide.vue';
	import NewContentSlide from '@/components/content/NewContentSlide.vue';
	import ContentBrowser from '@/components/content/ContentBrowser.vue';
	import EditTags from '@/components/tags/EditTags.vue'
	import {EventBus} from '@/services/EventBus.js';

	export default {
		name: "Content",
		components: {
			EditContentSlide,
			NewContentSlide,
			ContentBrowser,
			EditTags
		},
		async created() {
			(await isLoggedIn() === false) ? this.$router.push('/login') : '';
			EventBus.$emit('onCurrentShow', '');
		}
	}
</script>

<style scoped>
	
	#content {
		display: flex;
		flex-direction: column;
		flex-grow: 1;
	}
</style>